import { DEFAULT_DATE } from '../utilities/constants';
import { getValueFromLocalStorage } from '../utilities/utilityFunctions';
import { client, gql } from './Client';

const inspectionFilesQuery = gql`
  query inspectionFilesFeed(
    $siteId: Int!
    $disciplineId: Int!
    $lastModified: DateTime!
    $isLeadInspector: Boolean!
  ) {
    inspectionFilesFeed(
      siteId: $siteId
      disciplineId: $disciplineId
      lastModified: $lastModified
      isLeadInspector: $isLeadInspector
    ) {
      fileId
      fileUUID
      isDelete
      siteId
      disciplineId
      sizeMb
      extension
    }
  }
`;

const inspectionFiles = (siteId: number, disciplineId: number) =>
  client.query({
    query: inspectionFilesQuery,
    variables: {
      siteId,
      disciplineId,
      lastModified: DEFAULT_DATE,
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  });

export { inspectionFiles };
